<template>
    <a :href="data.url" class="c-zn-card" target="_blank"> 
        <div class="c-zn-card-meta">
            <span class="c-zn-card-meta__category" v-if="data.folder.length > 0">
                {{ data.folder[0].name }}
            </span>
            <div class="c-zn-card-meta__code" v-if="data.code">
                {{ data.code }}
            </div>
        </div>
        <div class="c-zn-card-data">
            <span class="c-zn-card-data__date">
                {{ date}}
            </span>
            <div class="c-zn-card-datawrapper">
                <h3 class="c-zn-card__title">
                    {{ data.title }}
                </h3>
                <svg class="icon icon-icon_download"><use xlink:href="#icon-icon_download"></use></svg>
            </div>
        </div>
        <div class="c-zn-card-tags" v-if="data.tags.length > 0 || data.znform_id">
            <span v-if="data.znform_id">{{ data.znform_id }}</span>
            <span v-for="tag in data.tags" v-if="data.tags.length > 0 ">{{ tag.name }}</span>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        data: Object,
    },
    computed: {
        date() {
            const date = new Date(this.data.date);
            return date.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            })
        }
    }
}
</script>